module.exports = __webpack_public_path__ + "media/images/welcome/feature2-2-bd19365b208bb41011d3dd9339135cbe.png";